export default __webpack_public_path__ + "static/media/EG_Mix-3.a985cdf4.wav";